import React from 'react';
import axios from 'axios';
import { DashboardShell, TileSection, listCount, useRefreshKey, useAnyVisible } from '../../shared/LiveDashboard';

// Accounting Dashboard: a live starter (shared/LiveDashboard.js).

// One QuickBooks link state, for Products or Customers.
const productLinks = (quickbooks) => ({
  screen: 'products',
  icon: 'Stock On Hand',
  count: listCount('/api/products', { status: 'active', quickbooks, limit: 1 }),
  to: '/products',
  state: { initialFilters: { status: 'active', quickbooks } },
});
const customerLinks = (quickbooks) => ({
  screen: 'sales-customers',
  icon: 'New Customers',
  count: listCount('/api/customers', { scope: 'lifecycle', lifecycle: 'customers', status: 'active', quickbooks, limit: 1 }),
  to: '/sales-customers',
  state: { initialFilters: { status: 'active', quickbooks } },
});
// Tax Codes, Payment Terms and Bank Accounts with no QuickBooks match, from
// the Mappings tab's own completeness check.
const unmatched = (field) => ({
  screen: 'accounting-quickbooks',
  icon: 'Bills Due',
  count: () => axios.get('/api/quickbooks/mappings/status').then((res) => res.data.data?.[field] ?? 0),
  to: '/accounting-quickbooks?tab=mappings',
});

const QUICKBOOKS = [
  { key: 'products-unmatched', label: 'Products Not Linked', ...productLinks('unmatched') },
  { key: 'products-attention', label: 'Products Needing Attention', ...productLinks('needs_attention') },
  { key: 'customers-unmatched', label: 'Customers Not Linked', ...customerLinks('unmatched') },
  { key: 'customers-attention', label: 'Customers Needing Attention', ...customerLinks('needs_attention') },
  { key: 'tax-codes', label: 'Tax Codes Not Matched', ...unmatched('unmatched_tax_codes') },
  { key: 'payment-terms', label: 'Payment Terms Not Matched', ...unmatched('unmatched_payment_terms') },
  { key: 'bank-accounts', label: 'Bank Accounts Not Matched', ...unmatched('unmatched_bank_accounts') },
];

function AccountingDashboard() {
  const [refreshKey, refresh] = useRefreshKey();
  const any = useAnyVisible(QUICKBOOKS);
  return (
    <DashboardShell
      title="Accounting Dashboard"
      description={any ? 'What still needs linking to QuickBooks.' : 'Your Roles don’t include any of this dashboard’s cards.'}
      onRefresh={refresh}
    >
      <TileSection title="QuickBooks Links" tiles={QUICKBOOKS} refreshKey={refreshKey} />
    </DashboardShell>
  );
}

export default AccountingDashboard;
